export default {
  "metrics_select_metrics": "Metrics",
  "metrics_select_search_for_metrics": "Search for Metrics",
  "metrics_select_all": "All",
}
